import { Checkbox, Menu, Select } from "antd";
import React from "react";
import { TFacet } from "../../../model/SearchResponse";
import { TSearchQueryRequest } from "../../../service/SearchService";

const { Option } = Select;

export interface Props {
  years: number[];
  facet?: TFacet;
  onSelect(value: string): any;
  removeSelected(value: string): any;
  selectedYears?: string[];
  property: string;
  searchQuery?: TSearchQueryRequest;
  translate;
}

export interface State {}

export default class YearList extends React.Component<Props, State> {
  render() {
    const {
      years,
      facet,
      onSelect,
      removeSelected,
      selectedYears,
      translate,
      searchQuery,
      property
    } = this.props;

    const onClick = (item) => {
      onSelect?.(item);
    };

    return (
      <>
        <Checkbox.Group
          style={{ marginLeft: 18 }}
          value={selectedYears}
          onChange={(list) => {
            onClick?.(list.join(","));
          }}
        >
          {years.slice(0, 5).map((item, index) => {
            let count = 0;
            if (facet) {
              let properties = Object.keys(facet).filter(
                (k) => k.slice(0, 4) === item.toString()
              );
              properties.forEach((property) => {
                count += facet[property];
              });
            }
            let label = `${item} (${count})`;
            return (
              <div style={{ marginBottom: 4 }} key={`year-check-${index}`}>
                <Checkbox
                  key={`year-check-item-${index}`}
                  value={item.toString()}
                >
                  {label}
                </Checkbox>
              </div>
            );
          })}
        </Checkbox.Group>
        <Select
          size={"middle"}
          style={{ width: "100%" }}
          placeholder={translate("search.sider.show_more")}
          onChange={(val) => val && onClick(val.toString())}
        >
          {years.slice(5).map((item) => {
            let count = 0;
            if (facet) {
              let properties = Object.keys(facet).filter(
                (k) => k.slice(0, 4) === item.toString()
              );
              properties.forEach((property) => {
                count += facet[property];
              });
            }
            return (
              <Option
                key={`menuyear-${item}`}
                value={item}
                className={"search-sider-option"}
              >
                {`${item} (${count})`}
              </Option>
            );
          })}
        </Select>
      </>
    );
  }
}
